export const getResetPasswordHashFromUrl = (): string | null => {
  const searchParams = new URLSearchParams(window.location.search);
  const searchHash = searchParams.get('reset_password_hash');

  if (searchHash) return searchHash;

  const hash = window.location.hash.replace(/^#/, '');
  if (!hash) return null;

  const hashParams = new URLSearchParams(hash.includes('?') ? hash.split('?')[1] : hash);
  return hashParams.get('reset_password_hash');
};
